import React, { useEffect, useState } from "react";
import axios from "axios";
import "./TempleTimingsInfo.css";

export default function TempleTimingsInfo() {

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    axios
      .get("https://spst.in/myapp/api/fetch_timings.php")
      .then((res) => {

        const enabledData = Array.isArray(res.data)
          ? res.data.filter(
              (item) => Number(item.status) === 1
            )
          : [];

        setData(enabledData);

      })
      .catch((error) => {
        console.error("Error fetching timings:", error);
      })
      .finally(() => {
        setLoading(false);
      });

  }, []);

  return (
    <section className="temple-timings-section">

      <div className="timings-wrapper">

        {/* Section Header */}
        <div className="timings-header">
          <span className="header-line"></span>

          <div className="header-icon">
            🛕
          </div>

          <div>
            <span className="header-small">
              TEMPLE SCHEDULE
            </span>

            <h2>
              Temple Timings
            </h2>
          </div>

          <span className="header-line"></span>
        </div>


        {loading && (
          <div className="timings-loading">
            Loading timings...
          </div>
        )}


        {!loading && data.length === 0 && (
          <div className="timings-loading">
            No timings available
          </div>
        )}


        <div className="timings-list">

          {data.map((row, index) => (

            <div
              className="timing-row"
              key={row.id}
            >

              {/* Number */}
              <div className="timing-number">
                {/* {String(index + 1).padStart(2, "0")} */}
              </div>


              {/* Title */}
              <div className="timing-name">

                <span className="name-icon">
                  🛕
                </span>

                <h3>
                  {row.heading}
                </h3>

              </div>


              {/* Timings */}
              <div className="timing-details">

                {/* Morning */}
                {Array.isArray(row.morning) &&
                  row.morning.length > 0 && (

                    <div className="timing-period morning-period">

                      <div className="period-label">

                        <span className="period-icon">
                          ☀
                        </span>

                        <span>
                          Morning
                        </span>

                      </div>


                      <div className="time-list">

                        {row.morning.map((m) => (

                          <span
                            className="time-item"
                            key={m.id}
                          >
                            {m.time_value}
                          </span>

                        ))}

                      </div>

                    </div>

                )}


                {/* Evening */}
                {Array.isArray(row.evening) &&
                  row.evening.length > 0 && (

                    <div className="timing-period evening-period">

                      <div className="period-label">

                        <span className="period-icon">
                          ☾
                        </span>

                        <span>
                          Evening
                        </span>

                      </div>


                      <div className="time-list">

                        {row.evening.map((e) => (

                          <span
                            className="time-item"
                            key={e.id}
                          >
                            {e.time_value}
                          </span>

                        ))}

                      </div>

                    </div>

                )}

              </div>

            </div>

          ))}

        </div>

      </div>

    </section>
  );
}